var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4 0H29c-1 0-1.7.8-1.7 1.7v9.7c0 1 .8 1.8 1.7 1.8 1 0 1.8-.8 1.8-1.8v-8h16v16h-24V1.7c0-1-.7-1.7-1.7-1.7H1.7C.7 0 0 .8 0 1.7v19.4c0 1 .8 1.8 1.7 1.8h17.7v23.6h-16V30.6H12c1 0 1.7-.8 1.7-1.7 0-1-.7-1.8-1.7-1.8H1.7C.7 27.1 0 28 0 29v19.4c0 1 .8 1.7 1.7 1.7h19.4c1 0 1.8-.8 1.8-1.7V22.9h25.5c1 0 1.8-.8 1.8-1.8V1.7c0-1-.8-1.7-1.8-1.7zm-45 19.4v-16h16v16h-16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4 27.1H29c-1 0-1.7.8-1.7 1.8v19.4c0 1 .8 1.7 1.7 1.7h19.4c1 0 1.8-.8 1.8-1.7V28.9c0-1-.8-1.8-1.8-1.8zm-1.7 19.4h-16V30.6h16v16z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.5dc27f33.svg";
export { ForwardRef as ReactComponent };